import * as React from 'react';

import { useCareerAcademyVariant } from 'bundles/unified-career-academy/contexts/CareerAcademyVariantContext';
import { EnterpriseCareerAcademyFreemiumPageContent } from 'bundles/unified-career-academy/pages/enterprise/career-academy/EnterpriseCareerAcademyFreemiumPageContent';
import EnterprisePageRootContent from 'bundles/unified-career-academy/pages/enterprise/career-academy/EnterprisePageRootContent';
import { isCareerAcademyFreemiumEnabled } from 'bundles/unified-career-academy/utils/helpers';

export const EnterprisePageDirector = () => {
  const careerAcademyVariant = useCareerAcademyVariant();
  const isCareerAcademyFreemium = isCareerAcademyFreemiumEnabled(careerAcademyVariant);

  if (isCareerAcademyFreemium) {
    return <EnterpriseCareerAcademyFreemiumPageContent />;
  }

  return <EnterprisePageRootContent />;
};
